import React from "react";
import Portal from "react-portal";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./Popover.css";
import shared from "../../../shared.css";

export default class Popover extends React.Component {
  constructor(props) {
    super(props);

    this.handleOutsideEvent = this._handleOutsideEvent.bind(this);
    this.correctPosition = this._correctPosition.bind(this);
    this.state = { position: this.props.position };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.isOpened && nextProps.isOpened) {
      document.addEventListener("mousedown", this.handleOutsideEvent, false);
      document.addEventListener("focus", this.handleOutsideEvent, true);
    } else if (this.props.isOpened && !nextProps.isOpened) {
      document.removeEventListener("mousedown", this.handleOutsideEvent, false);
      document.removeEventListener("focus", this.handleOutsideEvent, true);
    }

    if (nextProps.position) {
      // fix scroll problem
      if (nextProps.position.top) {
        if (!isNaN(nextProps.position.top)) {
          nextProps.position.top += window.scrollY;

          // when position.top is defined in rems
        } else {
          nextProps.position.top = `calc(${nextProps.position.top} + ${window.scrollY}px)`;
        }
      }

      this.setState({ position: nextProps.position });
    }
  }

  _correctPosition() {
    if (!this.node) return;

    // TODO: Add utils for converting from rem to px.
    const BUFFER = parseFloat(shared["scale-3"]) * 10;

    const rect = this.node.getBoundingClientRect();
    let position;

    // boundary checks
    if (rect.left <= BUFFER) {
      position = { ...this.state.position, left: BUFFER, transform: "none" };
    } else if (rect.right - window.innerWidth >= BUFFER) {
      position = {
        ...this.state.position,
        right: BUFFER,
        left: undefined,
      };
    }

    if (
      position &&
      this.state.position &&
      (position.left !== this.state.position.left ||
        position.right !== this.state.position.right)
    ) {
      this.setState({ position });
    }
  }

  _handleOutsideEvent(e) {
    if (this.props.isOpened) {
      if (!this.node || this.node.contains(e.target)) {
        return;
      }

      if (this.props.closeModal) {
        this.props.closeModal(e);
      }
    }
  }

  render() {
    return (
      <Portal isOpened={this.props.isOpened}>
        <div
          className={classNames(styles.root, this.props.className)}
          style={this.state.position}
          ref={node => {
            this.node = node;
            this.correctPosition();
          }}
        >
          {this.props.children}
        </div>
      </Portal>
    );
  }
}

Popover.propTypes = {
  isOpened: PropTypes.bool.isRequired,
  className: PropTypes.string,
  closeModal: PropTypes.func,
  position: PropTypes.object,
};
